import React from "react";
import styles from "./index.module.scss";
import { Popover } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";
import classNames from "classnames";

interface UserAvatarProps {
    isTeacher?: boolean;
    userNo: string;
    userName: string;
    className?: string;
    size?: number;
    placement?: TooltipPlacement;
    visible?: boolean; // 是否弹出用户信息, 匿名用户可以不弹出
}

export default function UserAvatar({
    isTeacher = false,
    className,
    userNo,
    userName,
    size,
    placement = "left",
    visible = true
}: UserAvatarProps) {
    const contentPopover = (
        <div className={styles.popover}>
            <div>{userName}</div>
            <div>{userNo}</div>
        </div>
    );

    const extraProps = visible ? {} : { visible: false };

    return (
        <Popover
            className={className}
            placement={placement}
            content={contentPopover}
            overlayClassName={classNames({
                [styles.teacher]: isTeacher
            })}
            {...extraProps}>
            <div
                className={classNames(styles.icon, {
                    [styles.teacher]: isTeacher
                })}
                style={size ? { width: size, height: size } : undefined}
            />
        </Popover>
    );
}
